'use strict';

angular.module('amexReconciliationApp')
    .service('TransactionFieldModel', function (ModelFactory,
                                                $filter,
                                                $rootScope,
                                                SiteConfigModel,
                                                UserModel,
                                                TransactionSearchModel,
                                                UserPreferencesRepository) {

        var model = ModelFactory.create('TransactionFieldModel', ['selectedField']);
        var currentRole;
        var currentIsPreAuth;
        var userPreferences;
        var getMerchantLocation = function (transaction) {
            var city = _.get(transaction, 'merchantCity', '');
            var state = _.get(transaction, 'merchantState', '');
            var country = _.get(transaction, 'merchantCountry', '');

            return state === '' ? (country === '' ? city : city + ', ' + country) : city + ', ' + state;
        };


        model.selectedHeaderColumnsArray = SiteConfigModel.selectedHeaderColumns(SiteConfigModel.getAvailableColumns(), TransactionSearchModel.siteNumber());


        var getCardmemberNameAndNumber = function (transaction) {
            var cardmemberName = _.get(transaction, 'cardmemberName', '');

            var NON_BREAKING_HYPHEN = '‑';
            var cardNumber = _.get(transaction, 'cardNumber', '').replace('-', NON_BREAKING_HYPHEN);

            return cardmemberName + ' (' + cardNumber + ')';
        };

        var getLocalAmountAndCurrencyCode = function (transaction) {
            var currencyCode = _.get(transaction, 'details.localCurrency');
            var localAmount = _.get(transaction, 'details.localAmount');

            return $filter('userPreferenceCurrencyFormat')(localAmount, UserModel.getCurrencyFormat()) + ' (' + currencyCode + ')';
        };

        var getPreAuthId = function (transaction) {
            if (transaction.preAuthData && transaction.preAuthData.length > 0) {
                return _.get(transaction.preAuthData[0].id, 'preAuthorizationId', '');
            } else {
                return '';
            }
        };

        var getTravelerName = function (transaction) {
            return _.get(transaction, 'details.travelerName', '');
        };
        var getTicketNumber = function (transaction) {
            return _.get(transaction, 'details.ticketNumber', '');
        };
        //GCSR-2966-Cardmember reference data is not displayed in the table
        var getCardmemberReference2 = function (transaction) {
            return _.get(transaction, 'details.travelerName', '');
        };
        var getCardmemberReference3 = function (transaction) {
            return _.get(transaction, 'details.cardmemberReference3', '');
        };
        //GCSR-2966-Cardmember reference data is not displayed in the table
        var getCardmemberReference4 = function (transaction) {
            return _.get(transaction, 'details.cardmemberReference4', '');
        };
        var getInvoiceNumber = function (transaction) {
            return _.get(transaction.transactionThirdPartyData[0], 'poNumber', '');
        };
        var getOpenText17 = function (transaction) {
            return _.get(transaction.transactionThirdPartyData[0], 'openText17', '');
        };
        var getOpenText18 = function (transaction) {
            return _.get(transaction.transactionThirdPartyData[0], 'openText18', '');
        };
        var getOpenText19 = function (transaction) {
            return _.get(transaction.transactionThirdPartyData[0], 'openText19', '');
        };
        var getOpenText20 = function (transaction) {
            return _.get(transaction.transactionThirdPartyData[0], 'openText20', '');
        };
        var getTRANSACTIONREFNUMBER = function (transaction) {
            return _.get(transaction, 'transRefNo', '');
        };

        var fields = {
            'cardmemberName': 'cardmemberName',
            'cardmemberReference1': 'details.cardmemberReference1',
            'descriptionLine1': 'details.descriptionLine1',
            'descriptionLine2': 'details.descriptionLine2',
            'descriptionLine3': 'details.descriptionLine3',
            'descriptionLine4': 'details.routing',
            'Merchant Reference Number': 'details.merchantReference',
            'merchantLocation': 'details.merchantLocation',
            'businessProcessDate': 'processDate',
            'localAmountAndCurrencyCode': '',
            'transactionLastUpdated': 'updatedAt',
            'amount': 'amount',
            'billedTaxAmount': 'details.billedTaxAmount',
            'poNumber#': 'lineItemDetails.purchaseOrderNumber',
            'matchedPO': 'details.matchedPO'

        };

        model.getFields = function () {
            var fieldNames = _.keys(fields);
            if (TransactionSearchModel.isBcaManager() || TransactionSearchModel.isAccountingManager()) {
                fieldNames.splice(1, 0, 'cardmemberNameAndNumber');
            }
            if (SiteConfigModel.isPreAuth()) {
                fieldNames.push('preAuthId');
            }
            if (SiteConfigModel.isVngBtaProductType()) {
                fieldNames.push('cardmemberReference2');
                fieldNames.push('cardmemberReference3');
                fieldNames.push('ticketNumber');
                fieldNames.push('travelerName');
                fieldNames.push('OpenText17');
                fieldNames.push('OpenText18');
                fieldNames.push('OpenText19');
                fieldNames.push('OpenText20');
                fieldNames.push('TRANSACTIONREFNUMBER');
            }
            if (SiteConfigModel.isBtaProductType()) {
                fieldNames.unshift('ticketNumber');
                fieldNames.push('cardmemberReference2');
                fieldNames.push('cardmemberReference3');
                fieldNames.push('travelerName');
                fieldNames.push('OpenText17');
                fieldNames.push('OpenText18');
                fieldNames.push('OpenText19');
                fieldNames.push('OpenText20');
                fieldNames.push('TRANSACTIONREFNUMBER');
            }
            return fieldNames;
        };

        model.getGivenFieldValue = function (fieldName, transaction) {
            model.selectedField(fieldName);
            return model.getFieldValue(transaction);
        };
        model.getFieldValue = function (transaction) {
            var dateFormat, date;

            if (model.selectedField() === 'cardmemberNameAndNumber') {
                return getCardmemberNameAndNumber(transaction);
            }

            if (model.selectedField() === 'localAmountAndCurrencyCode') {
                return getLocalAmountAndCurrencyCode(transaction);
            }

            if (model.selectedField() === 'merchantLocation') {
                return getMerchantLocation(transaction);
            }

            if (model.selectedField() === 'preAuthId') {
                return getPreAuthId(transaction);
            }

            if (model.selectedField() === 'travelerName') {
                return getTravelerName(transaction);
            }
            if (model.selectedField() === 'ticketNumber') {
                return getTicketNumber(transaction);
            }
            if (model.selectedField() === 'cardmemberReference2') {
                return getCardmemberReference2(transaction);
            }
            if (model.selectedField() === 'cardmemberReference3') {
                return getCardmemberReference3(transaction);
            }
            if (model.selectedField() === 'cardmemberReference4') {
                return getCardmemberReference4(transaction);
            }
            if (model.selectedField() === 'matchedPO') {
                return getInvoiceNumber(transaction);
            }
            if (model.selectedField() === 'OpenText17') {
                return getOpenText17(transaction);
            }
            if (model.selectedField() === 'OpenText18') {
                return getOpenText18(transaction);
            }
            if (model.selectedField() === 'OpenText19') {
                return getOpenText19(transaction);
            }
            if (model.selectedField() === 'OpenText20') {
                return getOpenText20(transaction);
            }
            var fieldValue = _.get(transaction, fields[model.selectedField()]);

            if (model.selectedField() === 'billedTaxAmount') {
                return $filter('userPreferenceCurrencyFormat')(fieldValue, UserModel.getCurrencyFormat());
            }
            if (model.selectedField() === 'TRANSACTIONREFNUMBER') {
                return getTRANSACTIONREFNUMBER(transaction);
            }

            if (model.selectedField() === 'transactionLastUpdated') {
                if (fieldValue !== null) {
                    dateFormat = $filter('userPreferenceDateFormat');
                    date = dateFormat(fieldValue, 'withTime');
                    return date;
                } else {
                    return '';
                }
            }

            if (model.selectedField() === 'businessProcessDate') {
                if (fieldValue !== null) {
                    dateFormat = $filter('userPreferenceDateFormat');
                    date = dateFormat(fieldValue);
                    return date;
                } else {
                    return '';
                }
            }

            return fieldValue;
        };

        model.isNumber = function () {
            return model.selectedField() === 'localAmountAndCurrencyCode' || model.selectedField() === 'billedTaxAmount';
        };

        function updateSelectedField() {

            var newParamsRole = _.get(TransactionSearchModel.role(), 'name', '');
            var newIsPreAuth = SiteConfigModel.isPreAuth();
            var defaultField;
            userPreferences = UserModel.currentUserPreferences();

            if (userPreferences != null && userPreferences.transactionColumnPreferences != null && userPreferences.transactionColumnPreferences.customizablecolumn != null) {
                defaultField = userPreferences.transactionColumnPreferences.customizablecolumn;
                model.selectedField(defaultField);
            } else {
                if (newParamsRole !== currentRole || newIsPreAuth !== currentIsPreAuth) {
                    currentRole = newParamsRole;
                    currentIsPreAuth = newIsPreAuth;

                    if (SiteConfigModel.isPreAuth()) {
                        defaultField = 'preAuthId';
                    } else {
                        defaultField = getDefaultFieldForCurrentRole();
                    }

                    model.selectedField(defaultField);

                }
            }

        }

        function getDefaultFieldForCurrentRole() {
            if (SiteConfigModel.isBtaProductType()) {
                return 'ticketNumber';
            }
            if (TransactionSearchModel.isBcaManager() || TransactionSearchModel.isAccountingManager()) {
                return 'cardmemberName';
            }
            if (TransactionSearchModel.isCardMember() || TransactionSearchModel.isCardManager()) {
                return 'descriptionLine1';
            }

        }

        model.updateDefaultColumn = function () {
            if (model.selectedField() != undefined && model.getFields().indexOf(model.selectedField()) === -1) {
                model.selectedField(getDefaultFieldForCurrentRole());
                if (userPreferences != null && userPreferences.transactionColumnPreferences != null) {
                    var transactionColumnPreferences = userPreferences.transactionColumnPreferences;
                    transactionColumnPreferences.customizablecolumn = getDefaultFieldForCurrentRole();
                    userPreferences.transactionColumnPreferences = transactionColumnPreferences;
                }
            }
        };

        model.updateTransactionColumnPreference = function (userSelectedColumn) {
            if (userPreferences != null && userPreferences.transactionColumnPreferences != null) {
                var transactionColumnPreferences = userPreferences.transactionColumnPreferences;
                transactionColumnPreferences.customizablecolumn = userSelectedColumn;
                userPreferences.transactionColumnPreferences = transactionColumnPreferences;
                UserPreferencesRepository.save(userPreferences)
                    .then(function () {
                        UserModel.currentUser().transactionColumnPreferences = userPreferences.transactionColumnPreferences;
                    });
            }
        };


        TransactionSearchModel.onParamsChanged($rootScope, updateSelectedField);
        SiteConfigModel.onSiteConfigChanged($rootScope, updateSelectedField);
        UserModel.onCurrentUserChanged($rootScope, updateSelectedField);

        model.isPartOfSpecialColumn = function (columnName) {
            return columnName in [
                'Lock Status (Icon)',
                'Status (Icon)',
                'Exception (Icon)',
                'LID (Icon)',
                'Comment (Icon)',
                'Approvals (Icon)'
            ];
        };

        return model;
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/TransactionFieldModel.js
// module id = 590
// module chunks = 0